(ns ycweb.app.website.stores.store-directory
  (:require
   [rum.core :as rum]
   [util.string :as str]
   [ycweb.app.website.common :as web-common]
   [ycweb.app.website.website :as website]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.scroll :as scroll]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

(rum/defc store-detail-card
  [app-atom
   {:store/keys
    [city address google-place-id maps_link today-opening-time today-closing-time
     open? special-date-description tel]
    :ent/keys
    [display-name]
    :as store}]

  [:article.store-loc-card
   {:class (u/bem :card [:no-hover] :text-card [:medium])}
   [:header.store-loc-card__header
    {:class
     (u/bem
       :flex-grid-group
       [:valign-middle :align-left :flush-force])}
    [:div
     {:class (u/bem :flex-grid-block [:grow-1 :fluid])}
     [:div.flex-grid-content
      [:h2
       {:class (u/bem :yc-heading [:flush :small])}
       display-name]]]
    [:div
     {:class (u/bem :flex-grid-block [:fluid])}
     [:div.flex-grid-content
      [:span
       {:class (u/bem :text-pill [:light :tiny])}
       city]]]]
   [:p
    {:class (u/bem :yc-paragraph [:flush])}
    (str/prune address 60)
    " "
    [:a.text-link
     {:href maps_link :target "_blank"}
     "Get directions."]
    " "]
   [:footer.store-loc-card__footer
    {:class
     (u/bem
       :flex-grid-group
       [:valign-middle :align-left :flush-force])}
    [:div
     {:class (u/bem :flex-grid-block [:ml-grow-yes :ml-fluid])}
     [:div.flex-grid-content
      [:div
       {:class
        (u/bem
          :flex-grid-group
          [:valign-middle :align-left :flush-force])}
       [:div
        {:class (u/bem :flex-grid-block [:fluid])}
        [:div.flex-grid-content
         [:p
          {:class (u/bem :yc-paragraph [:flush])}
          [:i
           {:class
            (u/bem
              :icon
              [:inline :default :in-copy-left (if open? :success-green :error-red)])}]
          (cond
            open?
            [:b
             [:span.u-text-mint-green
              "Open today"]
             (str
               " — " today-opening-time " to " today-closing-time)
             (when (u/presence special-date-description)
               (str " (" special-date-description ")"))]

            :else
            [:b
             [:span.u-text-red
              (str
                "Closed today")
              (when (u/presence special-date-description)
                (str " (" special-date-description ")"))]])]]]
       [:div
        {:class (u/bem :flex-grid-block [:fluid])}
        [:div.flex-grid-content
         [:p
          {:class (u/bem :yc-paragraph [:flush])}
          "Phone: "
          [:a.text-link {:href (str "tel:" tel)} tel]]]]]]]
    [:div.store-loc-card__cta
     {:class (u/bem :flex-grid-block [:ml-fluid])}
     [:div.flex-grid-content
      (buttons/button-web "Store times and info"
        {:type :button
         :on-click #(grid/open-modal app-atom :stores-directory/store-detail-modal {:store store})
         :style :primary
         :size :small
         :flat-style :flat-to-raised})]]]])

(rum/defc store-detail-modal-body < rum/reactive [app-atom config-atom]
  (let [{:store/keys
         [suburb city address google-place-id opening-time closing-time postalcode
          open? tel email upcoming-store-times]
         :ent/keys
         [display-name]}
        (cmn/curact config-atom [:store])]
    [:div
     (headings/heading display-name {:type :h2 :size :default})
     (headings/heading "Contact details:" {:type :h3 :size :small})
     [:ul.yc-list
      [:li
       "Email: "
       [:a.text-link {:href (str "mailto:" email)} email]]
      [:li
       "Phone: "
       [:a.text-link {:href (str "tel:" tel)} tel]]]
     (headings/heading "Operating hours: (next 7 days)" {:type :h3 :size :small})
     [:table.simple-table.u-margin-bottom-24
      [:colgroup [:col] [:col] [:col]]
      (into
        [:tbody.simple-table]
        (map
          (fn [{:keys [weekday date opening-time closing-time open? special-date-description]}]
            [:tr
             [:td [:b weekday]]
             [:td.u-text-nowrap [:b date]]
             [:td
              (if open?
                [:b opening-time " to " closing-time]
                [:span.u-text-red "Closed"])
              (when (u/presence special-date-description)
                (str " (" special-date-description ")"))]])
          (sort-by :full-date upcoming-store-times)))]
     [:p.yc-paragraph
      [:b "Yuppiechef orders can be collected during these times."]
      " You'll receive an email notification with a unique QR code letting you know that your order is ready for collection."]
     (headings/heading "Address and directions:" {:type :h3 :size :small})
     (into
       [:p.yc-paragraph
        (map
          (fn [a-line]
            [:div
             a-line
             [:br]])
          (str/split address #","))
        (when suburb suburb)
        (when city [:br])
        city
        (when postalcode [:br])
        postalcode])
     [:div.u-margin-bottom-24
      {:class (u/bem :responsive-iframe-wrapper [:4x3])}
      [:iframe
       {:style {:border "0"}
        :src
        (str "https://www.google.com/maps/embed/v1/place?key=AIzaSyAOCQrlmxLRaX5Kw_JY3-5fiVtGGPeLKss&zoom=16&q="
          (if (u/presence google-place-id)
            (str "place_id:" google-place-id)
            (str (str/replace address #"[^A-Za-z0-9]" " ") "," suburb "," city "," postalcode))),
        :frameborder "0",
        :allowfullscreen ""}]]]))

(rum/defc store-detail-modal-footer [app-atom config-atom]
  (let [{:store/keys
         [maps_link]}
        (cmn/curact config-atom [:store])]
    (grid/button-row
      {:left-text "Cancel"
       :left-fn #(grid/close-modal app-atom)
       :left-no-icon true
       :right-text "Google Maps"
       :right-type :web
       :right-icon :arrow-right
       :right-options
       {:href maps_link
        :target "_blank"}})))

(defmethod grid/modal-config :stores-directory/store-detail-modal [_ _ _]
  {:body store-detail-modal-body
   :footer store-detail-modal-footer
   :modal-type :variable})

(rum/defc store-directory < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        stores (sort-by :ent/display-name (cmn/curact process-atom [:stores]))
        cities (sort (set (map #(:store/city %) stores)))
        selected-city (cmn/curact app-atom [:selected-city])

        filtered-stores
        (if (u/presence selected-city)
          (filter #(= (:store/city %) selected-city) stores)
          stores)]

    [:main
     {:id "main-content"}
     [:div.header-banner.u-bg-greenery
      [:div.header-banner__text-wrapper
       [:div.header-banner__text.u-text-white
        [:h1.header-banner__title "Store locator"]]]
      [:div.header-banner__image-wrapper
       (web-common/lazy-image app-atom
         "pagebuilder/651/yuppiechef-stores-header-banner-1564576349"
         {:class ["header-banner__image"]}
         {:w 960
          :mw 490
          :q "auto"
          :alt "Interior of a Yuppiechef retail store"})]]
     [:div.yc-section
      [:div
       {:class (u/bem :yc-section [:medium-underline])}
       [:div.yc-intro-text
        [:p
         "Spread between Cape Town, Johannesburg, Pretoria, Durban, Mbombela and Bloemfontein, Yuppiechef's growing number of stores stock a range of our top brands, customer favourites and our personal must-have items. In store, you're able to touch and feel a product before buying it, get advice on the perfect tool for the job and have someone show you how it works. And if it's not in store, we can deliver it to you. You can also choose to shop online and collect in store. Come in and have a browse, we'd love to meet you."]
        [:div.u-block-center.u-max-width-480
         [:div
          {:class (u/bem :flex-grid-group [:flush-force :flush])}
          [:div
           {:class (u/bem :flex-grid-block [:m-order-02 :m-1-2])}
           [:div.flex-grid-content
            (buttons/button-web "Find a store"
              {:on-click #(scroll/scroll-to-id % "js-store-locations")
               :style :primary
               :size :default
               :icon :location
               :full true})]]
          [:div
           {:class (u/bem :flex-grid-block [:m-1-2])}
           [:div.flex-grid-content
            (buttons/button-web "Store FAQs"
              (merge
                (urlstate/href-props app-atom "help" "article" {:id 173 :name "Yuppiechef-Retail-Stores-FAQs"})
                {:style :secondary
                 :size :default
                 :icon :help
                 :full true}))]]]]]]
      [:div
       {:id "js-store-locations" :class (u/bem :yc-section [:large])}
       [:div.form-field.u-max-width-320
        (forms/select "Filter by city:"
          (rum/cursor app-atom :selected-city)
          (concat [{:value "" :text "All cities"}]
            (map (fn [city] {:value city :text city}) cities))
          {:flush? true})]

       (into
         [:div.u-relative]
         (map
           (fn [store]
             (store-detail-card app-atom store)))
         filtered-stores)]
      (toaster/loading-overlay app-atom :web.store-directory)]]))

(defmethod flow/render-screen :web.store-directory [app-atom _]
  (website/screen-wrapper app-atom
    (store-directory app-atom)
    {:banner-type "Footer Ads" :banner-limit 4}))

(defmethod t/transition-open :web.store-directory [app-atom _ _]
  (toaster/open-overlay app-atom :web.store-directory)
  (comms/ajax-get :web.store-directory/list {}))

(defmethod comms/receive :web.store-directory/list [app-atom {:keys [stores]}]
  (let [process-atom (cmn/process-cursor app-atom)]
    (swap! process-atom assoc-in [:stores] stores)
    (toaster/close-overlay app-atom :web.store-directory)))